<template>
  <div>
      <template v-for="(meals, day) in mealsPerDay">
        <h2 class="blue darken-2 white--text">{{ parseDay(day) }}</h2>
        <v-layout class="my-2" row>
            <template v-for="(meal, key) in meals">
              <v-flex xs4 class="ml-2">
                <v-card>
                  <v-card-title>
                    <v-layout>
                      <v-flex class="text-xs-left" xs9>
                        <h2>{{meal.name}}</h2>
                      </v-flex>
                      <v-flex class="text-xs-right" xs3>
                        <v-icon @click="doCopy(meal)" class="copy-icon">far fa-copy</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-list dense>
                    <v-list-tile>
                      <v-list-tile-content><h3>Total Meal Count:</h3></v-list-tile-content>
                      <v-list-tile-content class="align-end"><h4>{{meal.total}}</h4></v-list-tile-content>
                    </v-list-tile>
                  </v-list>

                  <template v-if="key !== 'extras'">
                    <template v-for="stream in streams">
                      <v-divider></v-divider>
                      <h3 class="text-xs-left pl-3 py-1 blue lighten-5">{{ stream.name }}</h3>
                      <v-divider></v-divider>
                      <template v-for="(item, size) in meal[stream.id]">
                        <v-list dense v-if="item.standard > 0 || (item.substitutions && Object.entries(item.substitutions).length > 0)">
                          <v-list-tile>
                            <v-list-tile-content><strong>{{size.toUpperCase()}}</strong></v-list-tile-content>
                            <v-list-tile-content class="align-end"></v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                        <v-list dense v-if="item.standard > 0">
                          <v-list-tile>
                            <v-list-tile-content>Standard</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{item.standard}}</v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                        <template v-for="(value, key) in item.substitutions" v-if="value && value > 0">
                          <v-list dense>
                            <v-list-tile>
                              <v-list-tile-content v-if="substitutions[key]">{{substitutions[key].text.toUpperCase()}}</v-list-tile-content>
                              <v-list-tile-content v-else>{{key.toUpperCase()}}</v-list-tile-content>
                              <v-list-tile-content class="align-end">{{value}}</v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </template>
                      </template>
                    </template>
                  </template>

                  <v-list dense v-if="meal.custom.quantity > 0">
                    <v-divider></v-divider>
                    <v-list-tile v-if="meal.custom.quantity > 0" class="blue lighten-5">
                      <v-list-tile-content><h3>Custom meals</h3></v-list-tile-content>
                      <v-list-tile-content class="align-end pl-3"><h4>{{meal.custom.quantity}}</h4></v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </v-list>
                  <template v-if="meal.custom.quantity > 0" v-for="code in meal.custom.codes">
                    <v-list dense>
                      <v-list-tile>
                        <v-list-tile-content>{{code.value}}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{code.quantity}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </template>
                </v-card>
              </v-flex>
            </template>

        </v-layout>
      </template>
      <v-snackbar
        top
        v-model="snackbar"
      >
        Copied!
        <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>
  </div>
</template>
<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';

  function initialState() {
    return {
      snackbar: false,
      mealsPerDay: {},
      meals: {}
    }
  }

  export default{
    data(){
      return initialState();
    },
    created() {
        this.meals = this.createMealsData();
    },
    mounted(){
      this.initOrders();
    },
    watch:{
      orders: function(){
        this.resetData();
        this.initOrders();
      }
    },
    methods:{
        createMealsData() {
            const summary = {
                breakfast: {
                    name: 'Breakfast',
                    total: 0,
                    custom: {
                        quantity: 0,
                        codes: []
                    }
                },
                lunch: {
                    name: 'Lunch',
                    total: 0,
                    custom: {
                        quantity: 0,
                        codes: []
                    }
                },
                dinner: {
                    name: 'Dinner',
                    total: 0,
                    custom: {
                        quantity: 0,
                        codes: []
                    }
                },
                extras: { name: 'Extras',
                    total: 0,
                    custom: {
                        quantity: 0,
                        codes: []
                    }
                }
            };
            for (const stream of this.streams) {
                summary.breakfast[stream.id] = {name: stream.name, total: 0};
                summary.lunch[stream.id] = {name: stream.name, total: 0};
                summary.dinner[stream.id] = {name: stream.name, total: 0};
                for (const key in stream.sizes) {
                    summary.breakfast[stream.id][key] = { standard: 0, substitutions:{}, name: stream.sizes[key].kitchen_description };
                    summary.lunch[stream.id][key] = { standard: 0, substitutions:{}, name: stream.sizes[key].kitchen_description };
                    summary.dinner[stream.id][key] = { standard: 0, substitutions:{}, name: stream.sizes[key].kitchen_description };
                }
            }
            return summary;
        },
      getCustomQuantity: function(meals, tod){
        let quantity = 0;
        if(meals && meals.length > 0){
          for(let meal of meals){
            if(meal.quantity){
              quantity += meal.quantity;
            }
          }
        }
        return quantity;
      },
      initOrders: function(){
        this.resetData();
        for(let order of this.orders){
          for (let day of this.daysGroup) {
            this.mealsPerDay[day] = this.mealsPerDay[day] || this.createMealsData();
            this.mealsPerDay[day].breakfast.total += order[day].breakfast;
            this.mealsPerDay[day].lunch.total += order[day].lunch;
            this.mealsPerDay[day].dinner.total += order[day].dinner;

            let user = this.users[order.uid];
            let stream = this.plans[user.plan].stream;
            let size = user.meal_size || 'medium';
            this.mealsPerDay[day].breakfast[stream][size].standard += (parseInt(order[day].breakfast) || 0);
            this.mealsPerDay[day].lunch[stream][size].standard += order[day].lunch;
            this.mealsPerDay[day].dinner[stream][size].standard += order[day].dinner;

            this.setSubstitutions(this.mealsPerDay[day].breakfast[stream][size], order, 'breakfast', day);
            this.setSubstitutions(this.mealsPerDay[day].lunch[stream][size], order, 'lunch', day);
            this.setSubstitutions(this.mealsPerDay[day].dinner[stream][size], order, 'dinner', day);

            if(order[day].custom && order[day].custom.length > 0){
              this.getCodes(order[day].custom);
              for(let meal of order[day].custom){
                if(meal && meal.tod){
                  this.mealsPerDay[day][meal.tod].custom.quantity += meal.quantity;
                  this.mealsPerDay[day][meal.tod].total += meal.quantity;
                }
              }
            }
          }
        }
      },
      setSubstitutions: function (meal, order, tod, day) {
        if(order.substitutions) {
          meal.standard -= order[day][tod];

          if(order.substitutions.length > 1){
            let key = null;
            for(let substitution of order.substitutions){
              let text = this.substitutions[substitution] ? this.substitutions[substitution].text : substitution;
              key = key ? key + ", " + text : text;
            }
            meal.substitutions[key] = meal.substitutions[key] + order[day][tod] || order[day][tod];
          } else {
              let substitution = order.substitutions[0];
              meal.substitutions[substitution] = meal.substitutions[substitution] + order[day][tod] || order[day][tod];
              if(meal.substitutions[substitution] === 0) {
                delete meal.substitutions[substitution];
              }
          }
        }
      },
      resetData: function(){
        this.meals = this.createMealsData();
        this.mealsPerDay = {};
      },
      createSubstitutionString(substitutions) {
        let msg = '';
        if(substitutions){
          for(let key in substitutions){
            msg += '\t\t- ' + substitutions[key] + ' ' + (this.substitutions[key] ? this.substitutions[key].text.toUpperCase() : key.toUpperCase()) + '\n';
          }
        }
        return msg;
      },
      doCopy: function (meal) {
        let message = meal.name + '\n';
        message += 'Total order: ' + meal.total + '\n';

        for (const stream of this.streams) {
            message += stream.name + ":\n";
            for (const size in stream.sizes) {
                message += `\t• FN ${size}\n`;
                if (meal[stream.id] && meal[stream.id][size]) {
                  message += '\t\t- ' + meal[stream.id][size].standard + ' regular meals\n';
                  message += this.createSubstitutionString(meal[stream.id][size].substitutions);
                }
            }
        }

        if(meal.custom && meal.custom.quantity > 0){
          message += `\nCustom meals: ${meal.custom.quantity}\n`;
        }

        this.$copyText(message).then((e) => {
          this.snackbar = true;
        }, function (e) {
          alert('Can not copy');
          console.log(e);
        })
      },
      getCodes: function(orders){
        let codes = [];
        for(let order of orders){
          let code = '';
          if(order.order_type === 'chefs_choice') {
            let meal = this.fedMenu.chefs_choices[order.tod].find((item) => item.id === order.meal_id);
            code = meal.code;
          }
          let index = this.meals[order.tod].custom.codes.findIndex(item => item.value === code);
          if(index > -1){
            this.meals[order.tod].custom.codes[index].quantity += order.quantity;
          } else {
            this.meals[order.tod].custom.codes.push({value: code, quantity: order.quantity});
          }
        }
      },
      parseDay: function(day) {
        return moment().day(day).format('dddd');
      }
    },
    computed: {
      ...mapGetters({
        fedMenu: 'getMenu',
        chefsChoice: 'getChefsChoice',
        users: 'getUsers',
        substitutions: 'getSubstitutions',
        plans: 'getPlans',
        streams: 'getStreams'
      }),
    },
    props: {
      orders: Array,
      date: String,
      daysGroup: Array
    }
  }
</script>
<style>
  .copy-icon{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/BoxOverview.vue